import React, { useEffect, useState } from 'react';
import { Title, TextInput, PasswordInput, useNotify, useTranslate, minLength, useAuthState, useAuthenticated } from 'react-admin';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';

import SimpleForm from '../common/forms/SimpleForm';

import { getAccount, updateAccount } from '../../services/api';


const Account = () => {
    const [account, setAccount] = useState({});
    const notify = useNotify();
    const translate = useTranslate();
    const { isLoading, authenticated } = useAuthState();
    useAuthenticated();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getAccount();
                setAccount(response);
            } catch (error) {
                console.error(error);
            }
        };

        if (!isLoading && authenticated) {
            fetchData();
        }
    }, [isLoading, authenticated]);

    const handleSubmit = async (data) => {
        let formData = {
            firstname: data?.firstname,
            lastname: data?.lastname,
            organization_name: data?.organization_name,
            job_title: data?.job_title,
            organization_address: data?.organization_address,
            organization_website: data?.organization_website,
            organization_contact_name: data?.organization_contact_name,
            organization_contact_email: data?.organization_contact_email,
        };
        if (data?.password) {
            formData = { ...formData, password: data.password };
        }

        const response = await updateAccount(formData);
        if (response.errors) {
            let message = '';
            for (const error in response.errors) {
                message += `${error}: ${response.errors[error]}\n`;
            }
            notify(message, "warning");
        }
        else {
            notify(translate('Account updated'));
        }
    };

    return (
        <Box my={3}>
            <Card>
                <Title title="Account" />
                <SimpleForm record={account} onSubmit={handleSubmit} resource="account">
                    <><Typography variant="h5" gutterBottom>{translate('Account')}</Typography></>
                    <TextInput source="email" disabled />
                    <TextInput source="firstname" />
                    <TextInput source="lastname" />
                    <TextInput source="organization_name" />
                    <TextInput source="job_title" />
                    <TextInput source="organization_address" multiline rows="2" />
                    <TextInput source="organization_website" />
                    <TextInput source="organization_contact_name" />
                    <TextInput source="organization_contact_email" />
                    <PasswordInput source="password" validate={minLength(8)} />
                </SimpleForm>
            </Card>
        </Box>
    );
};

export default Account;